import StoryCard from "../Stories/StoryCardHome";
import RetailImg from "../../assets/story-1.png";
import MobileImg from "../../assets/story-2.png";
import MapImg from "../../assets/story-3.png";
import { stories } from "./stories.data";
import { Link } from "react-router-dom";

export default function SuccessStories() {
  return (
    <section className="relative overflow-hidden bg-white py-20">
      {/* Decorative shape */}
      <div className="pointer-events-none absolute -top-0 -left-40 h-[460px] w-[460px] rounded-full bg-gray-100" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto">
          <Link to="/success-stories" className="text-3xl font-bold text-gray-900">
            Success Stories
          </Link>
          <p className="mt-4 text-gray-600">
            Discover how we’ve helped businesses transform their operations
            through technology and innovation.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {stories.slice(0,3).map((story) => (
            <StoryCard key={story.title} {...story} />
          ))}
        </div>
      </div>
    </section>
  );
}
